import { useState } from 'react';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import ServiceFlow from './components/ServiceFlow';
import Profile from './components/Profile';
import Contact from './components/Contact';
import Footer from './components/Footer';

const navItems = [
  { id: 'problem', label: '課題' },
  { id: 'service', label: 'サービス' },
  { id: 'flow', label: '進め方' },
  { id: 'profile', label: 'プロフィール' },
  { id: 'contact', label: '無料相談' }
];

export default function HomePage() {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <div>
      <header className="topbar">
        <div className="topbar-inner">
          <div className="brand">
            <span className="name serif">EngiMind</span>
            <span className="kana">エンジマインド</span>
          </div>
          <nav className="top" aria-label="ページ内">
            {navItems.map((item) => (
              <button key={item.id} onClick={() => scrollToSection(item.id)}>
                {item.label}
              </button>
            ))}
          </nav>
          <button
            className={`menu-btn ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="メニュー"
            aria-expanded={menuOpen}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
        {menuOpen && (
          <div className="mobile-menu">
            {navItems.map((item) => (
              <button key={item.id} onClick={() => scrollToSection(item.id)}>
                {item.label}
              </button>
            ))}
          </div>
        )}
      </header>

      <main>
        <Hero />
        <Problem />
        <Solution />
        <ServiceFlow />
        <Profile />
        <Contact />
      </main>

      <Footer />
    </div>
  );
}
